export enum AppMenuEvents {
    MenuAvailable = 'AppMenu.MenuAvailable',
    MenuUnavailable = 'AppMenu.MenuUnavailable',
    ToggleMenu = 'AppMenu.ToggleMenu',
    ChangeSelectedLink = 'AppMenu.ChangeSelectedLink',
}